import React, { useState, useEffect } from "react";
import { UploadOutlined } from "@ant-design/icons";
import {
  Form,
  Input,
  Upload,
  Select,
  Modal,
  Button,
  Space,
  Row,
  Col,
  DatePicker,
  Table,
  InputNumber,
  Tooltip,
  Divider,
  Collapse,
  TimePicker,
  Switch,
  Input as AntInput,
} from "antd";

import { debounce } from 'lodash';
import {
  MinusCircleOutlined, PlusOutlined, CaretUpOutlined,    // ✅ Add this
  CaretDownOutlined
} from "@ant-design/icons";
import dayjs from "dayjs";
import { apiRequest } from "../../../../service/apiRequest";
import { showSuccess, showError } from "../../../../components/errorHandler";
// import type {
//     CompanyName,
// } from '../../../../types/CompanyName';
import type { UploadFile } from 'antd/es/upload/interface';
import type {
  Pn,
  Categories,
  FestivalItem,
} from "../../../../types/CreateProductType";

import type { SelectProps } from 'antd';

import type { ColumnsType } from 'antd/es/table';

import duration from 'dayjs/plugin/duration';
import { Dayjs } from "dayjs";

import customParseFormat from 'dayjs/plugin/customParseFormat';
import GstTypeModal from "../../ledger-mastes/gst-types/GstTypelModal";

dayjs.extend(customParseFormat);

const { Option } = Select;

const { Panel } = Collapse;

const MSME_REGEX = /^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/;


const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY'];


const { TextArea } = Input;
dayjs.extend(duration);

interface AccountHead {
  ah_id: number;
  ah_name: string;
  ah_parent: number;

}
interface SubHead {
  ah_id: number;
  ah_name: string;
}
interface LinkItem {
  link: string;
  description?: string;
  link_name?: string;
  link_url?: string;
}
interface BankItem {
  bank_name: string;
  ifsc: string;
  acc_no: string;
  address?: string;
  holder_name?: string;
  bank_account_account_no?: string;
  bank_account_bank_address?: string;
  bank_account_branch_name?: string;
  bank_account_holder_name?: string;
  bank_account_ifsc?: string;
}
interface AddressItem {
  type?: "residence" | "office";
  address?: string;
  landmark?: string;
  pincode?: string;
  address_type?: "residence" | "office";
  address_detail?: string;
  address_landmark?: string;
  address_pincode?: string;
}

interface PayrollItem {
  payroll_id?: number;
  payroll_ledger_id?: number;

  payroll_check_in?: string | Dayjs | null;
  payroll_check_out?: string | Dayjs | null;
  payroll_working_hours?: string;
  payroll_lunch_in?: string | Dayjs | null;
  payroll_lunch_out?: string | Dayjs | null;
  payroll_days_of_working?: string | string[] | null | undefined;
  payroll_days_off?: string | string[] | null | undefined;
  payroll_date_of_joining?: string | Dayjs | null;

  payroll_salary?: number | null;

  payroll_type_of_work?: string;
  payroll_increment_period?: string;
  payroll_increment_type?: string;
  payroll_increment_value?: number;

  payroll_late_allowance_time?: string | Dayjs | null;
  payroll_late_apply_half_day?: boolean | null;
  payroll_late_deduct_commission?: boolean | null;

  payroll_late_commission_percentage?: number | null;

  payroll_early_go_allowance_time?: string | Dayjs | null;
  payroll_early_apply_half_day?: boolean | null;
  payroll_early_deduct_commission?: boolean | null;
  payroll_early_commission_percentage?: number | null;
}
interface PhoneItem {
  first_name?: string;
  last_name?: string;
  label?: string;
  number?: string;
  designation?: string;
  email?: string;
  std_phone?: string;
  type?: string;
  std_code?: string;
  sms?: "Yes" | "No";
  contact_first_name?: string;
  contact_last_name?: string;
  contact_label?: string;
  contact_number?: string;
  contact_designation?: string;
  contact_email?: string;
  contact_type?: string;
  contact_std_phone?: string;
  contact_std_code?: string;
  contact_sms?: "Yes" | "No";
}
interface CategoryItem {
  category_id?: number;
  discount?: number;
  special_discount?: number;
  lcm_category_id?: number;
  lcm_discount?: number;
  lcm_special_discount?: number;
}
interface CategoryWithDiscount extends Categories {
  discount: number;
  special_discount: number;
  lcm_id?: number | null;
}

interface DocumentItem {
  document_id?: number;
  document_type: string;
  document_name: string;
  attachments: string;
}

interface LedgerFormValues {
  ledger_first_name: string;
  ledger_last_name?: string;
  ledger_account_head?: number;
  ledger_sub_account_head?: number;
  ledger_mobile_no?: string;
  ledger_company_name?: string;
  ledger_occupation?: number;
  ledger_designation?: number;
  ledger_opening_balance?: number;
  ledger_opening_type?: string;
  ledger_email?: string;
  ledger_gst_type?: string;
  ledger_gstin?: string;
  ledger_pan_no?: string;
  ledger_cin_no?: string;
  ledger_tin_no?: string;
  ledger_msme_reg_no?: string;
  ledger_import_export_code?: string;
  ledger_bill_to_bill?: 'Yes' | 'No';
  ledger_reserve_fund?: string;
  ledger_tds?: string;
  ledger_deals_in_company?: string[];
  ledger_deals_in_product?: string[];
  ledger_interest_rate?: number;
  ledger_interest_style?: string;
  ledger_credit_limit_day?: number;
  ledger_credit_limit_amount?: number;
  ledger_dob?: dayjs.Dayjs | null;
  ledger_marriage_anniversary?: dayjs.Dayjs | null;
  ledger_work_anniversary?: dayjs.Dayjs | null;
  ledger_status?: number;
  ledger_image?: string;
  links?: LinkItem[];
  banks?: BankItem[];
  addresses?: AddressItem[];
  payrolls?: PayrollItem[];
  phones?: PhoneItem[];
  categories?: CategoryItem[];
  documents?: DocumentItem[];
  payroll_working_hours?: string;
}


const occupations: string[] = [
  "Textile Merchant",
  "Fabric Shop Owner",
  "Tailor",
  "Fashion Designer",
  "Garment Worker",
  "Textile Designer",
  "Embroidery Specialist",
  "Boutique Owner",
  "Clothing Retailer",
  "Apparel Sales Associate",
  "Sewing Machine Operator",
  "Clothing Store Manager",
  "Alteration Specialist",
  "Software Engineer",
  "Data Scientist",
  "Product Manager",
  "Accountant",
  "Marketing Manager",
  "Sales Executive",
  "HR Manager",
  "Doctor",
  "Nurse",
  "Teacher",
  "Graphic Designer",
  "Photographer",
  "Lawyer",
  "Police Officer",
  "Electrician",
  "Mechanic",
  "Pilot",
  "Truck Driver",
  "Farmer",
  "Social Worker"
];


const designations: string[] = [
  // 🧵 Fabric & Textile Related
  "Tailor",
  "Senior Tailor",
  "Master Cutter",
  "Textile Designer",
  "Embroidery Worker",
  "Pattern Maker",
  "Garment Worker",
  "Sewing Machine Operator",
  "Fabric Store Manager",
  "Fabric Store Assistant",
  "Boutique Owner",
  "Boutique Manager",
  "Fashion Designer",
  "Production Supervisor",
  "Quality Checker",
  "Merchandiser",
  "Dyer",
  "Pressing Operator",
  "Clothing Retail Associate",

  // 🌐 Common Across All Fields
  "Owner",
  "Partner",
  "Manager",
  "Assistant Manager",
  "Supervisor",
  "Team Leader",
  "Executive",
  "Senior Executive",
  "Assistant",
  "Clerk",
  "Helper",
  "Operator",
  "Sales Executive",
  "Marketing Executive",
  "Accountant",
  "Cashier",
  "Receptionist",
  "Office Assistant",
  "Storekeeper",
  "Delivery Boy"
];




const occupationOptions = occupations.map((occ) => ({
  label: occ,
  value: occ
}));

const designationOptions = designations.map((des) => ({
  label: des,
  value: des
}));





const typeOfWorkOptions = [
  { label: 'Full-time', value: 'full_time' },
  { label: 'Part-time', value: 'part_time' },
  { label: 'Freelance', value: 'freelance' },
  { label: 'Contract', value: 'contract' },
  { label: 'Internship', value: 'internship' },
  { label: 'Temporary', value: 'temporary' },
  { label: 'Remote', value: 'remote' },
  { label: 'On-site', value: 'on_site' },
  { label: 'Hybrid', value: 'hybrid' },
  { label: 'Consulting', value: 'consulting' },
  { label: 'Volunteer', value: 'volunteer' },
  { label: 'Project-based', value: 'project_based' },
  { label: 'Apprenticeship', value: 'apprenticeship' },
  { label: 'Seasonal', value: 'seasonal' },
];

type YesNo = 'Yes' | 'No';


interface LedgerModalProps {
  visible: boolean;
  onCancel: () => void;
  onCreate: (data: any) => void;
  initialValues?: (LedgerFormValues & { ledger_id?: number }) | null;
  isEditMode?: boolean;
}



interface Ledger {
  ledger_id: number;
  ledger_account_head?: number;
  ah_name?: string;
}
interface GSTTypeItem {
  gst_type_id: number;
  gst_type_name: string;
  gst_type_status: number;
}
interface DesignationItem {
  designation_id: number;
  designation_name: string;
  designation_status: number;
}
interface OccupationItem {
  occupation_id: number;
  occupation_name: string;
  occupation_status: number;
}

const LedgerModal: React.FC<LedgerModalProps> = ({
  visible,
  onCancel,
  onCreate,
  initialValues = null,
  isEditMode = false,
}) => {
  const [form] = Form.useForm<LedgerFormValues>();
  const [accountHeads, setAccountHeads] = useState<AccountHead[]>([]);
  // const [companies, setCompany] = useState<CompanyName[]>([]);
  const [subHeads, setSubHeads] = useState<SubHead[]>([]);
  // const [categories, setCategories] = useState<Categories[]>([]);
  const [categories, setCategories] = useState<CategoryWithDiscount[]>([]);

  const [discounts, setDiscounts] = useState<Record<string, string>>({});


  const [imageFile, setImageFile] = useState<File | null>(null);
  const [profileImageFileList, setProfileImageFileList] = useState<UploadFile[]>([]);


  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');


  const [companyCollapsed, setCompanyCollapsed] = useState(false);

  const [gsttypes, setGSTTypes] = useState<GSTTypeItem[]>([]);
  const [isGSTTypeModalVisible, setIsGSTTypeModalVisible] = useState(false);



  type DataType = 'gsttypes';

  const fetchAllDataSequentially = async (types: DataType[] = ['gsttypes']) => {
    try {




    } catch (error) {
      showError('Failed to fetch some data');
      console.error(error);
    }
  };

  // load in render 
  useEffect(() => {
    debouncedFetchAllData();
  }, []);

  const debouncedFetchAllData = debounce(fetchAllDataSequentially, 500);

  // gsttypes
  const handleGSTTypeCreated = (data: GSTTypeItem) => {
    fetchAllDataSequentially(['gsttypes']);
    setIsGSTTypeModalVisible(false);
  };


  const [showCommissionOption, setShowCommissionOption] = useState(false);
  const [showEarlyGoCommissionOption, setShowEarlyGoCommissionOption] = useState(false);

  // pincode blur handler
  const handlePincodeBlur = async (pincode: string, name: number) => {
    if (!/^\d{6}$/.test(pincode)) return;

    try {
      const data = await apiRequest<{
        city: string;
        state: string;
        country: string;
      }>({
        method: "get",
        url: `lookup/pincode/${pincode}`, // change URL to your actual API endpoint
      });

      const currentAddresses = form.getFieldValue("addresses") || [];
      console.log("Current addresses before update:", currentAddresses);
      const updatedAddresses = [...currentAddresses];



      updatedAddresses[name] = {
        ...updatedAddresses[name],
      };
      console.log("Updated addresses:", updatedAddresses);

      form.setFieldsValue({ addresses: updatedAddresses });
      console.log("Form values after update:", form.getFieldsValue());
    } catch {
      showError("Could not fetch location data");
    }
  };

  // fetch data for dropdowns
  useEffect(() => {
    apiRequest<AccountHead[]>({ method: "get", url: `account-heads?status=1&ah_parent=0` })
      .then((resp) => setAccountHeads(resp))
      .catch(() => showError("Failed to load account heads"));

    apiRequest<SubHead[]>({ method: "get", url: `account-heads?status=1` })
      .then((resp) => setSubHeads(resp))
      .catch(() => showError("Failed to load sub heads"));




  }, []);




  const formatTimeSafe = (value: any) => {
    if (!value) return "";

    // DayJS object (from TimePicker)
    if (value?.format) {
      return value.format("hh:mm A");
    }

    // ISO strings
    if (typeof value === "string" && value.includes("T")) {
      return dayjs(value).format("hh:mm A");
    }

    // Already AM/PM string -> keep it
    if (/^[0-9]{1,2}:[0-9]{2} (AM|PM)$/i.test(value)) {
      return value;
    }

    return value;
  };



  useEffect(() => {
    const initializeForm = async () => {
      if (!visible) return;

      try {
        console.log("✅ Modal Opened");
        console.log("✅ Edit Mode:", isEditMode);
        console.log("✅ Initial Values:", initialValues);

        // Step 1: Categories fetch करो
        const categoriesData = await apiRequest<Categories[]>({
          method: "get",
          url: "category?status=1",
        });

        console.log("✅ Fetched Categories:", categoriesData);

        if (isEditMode && initialValues) {
          // ==================== EDIT MODE ====================

          // Step 2: Discount data fetch करो
          const discountData = await apiRequest<any[]>({
            method: "get",
            url: `ledger-category-mapping?ledger_id=${initialValues.ledger_id}`,
          });

          console.log("✅ Fetched Discount Data:", discountData);

          // Step 3: Merge categories with discount data
          const mergedCategories = categoriesData.map((cat) => {
            const matchedDiscount = discountData.find(
              (discount) => discount.lcm_category_id === cat.category_id
            );

            return {
              category_id: cat.category_id,
              category_name: cat.category_name,
              category_status: cat.category_status,
              discount: matchedDiscount ? Number(matchedDiscount.lcm_discount) : 0,
              special_discount: matchedDiscount ? Number(matchedDiscount.lcm_special_discount) : 0,
              lcm_id: matchedDiscount?.lcm_id || null,
            };
          });

          console.log("✅ Merged Categories:", mergedCategories);

          // Step 4: Prepare form values for edit mode
          const formValues: LedgerFormValues = {
            ...initialValues,
            ledger_dob: initialValues.ledger_dob ? dayjs(initialValues.ledger_dob) : null,

          };

          // Step 5: Handle ledger image
          if (initialValues.ledger_image) {
            const imageUrl = `${initialValues.ledger_image}`;
            setProfileImageFileList([
              {
                uid: '-1',
                name: 'image.png',
                status: 'done',
                url: imageUrl,
              },
            ]);
            setImageFile(null);
          } else {
            setProfileImageFileList([]);
            setImageFile(null);
          }

          // Step 6: Update categories state
          setCategories(mergedCategories);

          // Step 7: Set all form values including categories
          form.setFieldsValue({
            ...formValues,
            payrolls: formValues.payrolls,
            categories: mergedCategories, // ✅ Merged categories with discount
          });

          console.log("✅ Form Values Set Successfully");

        } else {
          // ==================== ADD MODE ====================

          // Blank categories for new ledger
          const blankCategories: CategoryWithDiscount[] = categoriesData.map((cat) => ({
            ...cat,
            discount: 0,
            special_discount: 0,
          }));

          console.log("✅ Blank Categories:", blankCategories);

          // Reset form
          form.resetFields();
          setImageFile(null);
          setProfileImageFileList([]);

          // Set categories
          setCategories(blankCategories);
          form.setFieldsValue({
            categories: blankCategories,
          });

          console.log("✅ Add Mode Initialized");
        }

      } catch (error) {
        showError("Failed to initialize form");
        console.error("❌ Error:", error);
      }
    };

    initializeForm();
  }, [visible, isEditMode, initialValues?.ledger_id, form]);


  const onFinish = async (values: LedgerFormValues) => {
    try {
      console.log("Form submit values:", values);

      const formData = new FormData();
      if (initialValues?.ledger_id) {
        formData.append("ledger_id", initialValues.ledger_id.toString());
      }
      // Ledger fields
      formData.append("ledger_first_name", values.ledger_first_name || "");
      formData.append("ledger_last_name", values.ledger_last_name || "");
      formData.append("ledger_mobile_no", values.ledger_mobile_no || "");
      formData.append("ledger_company_name", values.ledger_company_name || "");
      formData.append("ledger_occupation", `${values.ledger_occupation || ""}`);
      formData.append("ledger_image", values.ledger_image || "");
      formData.append("ledger_designation", `${values.ledger_designation || ""}`);
      formData.append(
        "ledger_opening_balance",
        (values.ledger_opening_balance ?? "").toString()
      );
      formData.append("ledger_opening_type", values.ledger_opening_type || "");
      formData.append("ledger_email", values.ledger_email || "");
      formData.append("ledger_gst_type", values.ledger_gst_type || "");
      formData.append("ledger_gstin", values.ledger_gstin || "");
      formData.append("ledger_pan_no", values.ledger_pan_no || "");
      formData.append("ledger_tin_no", values.ledger_tin_no || "");
      formData.append("ledger_cin_no", values.ledger_cin_no || "");
      formData.append("ledger_msme_reg_no", values.ledger_msme_reg_no || "")
      formData.append("ledger_import_export_code", values.ledger_import_export_code || "")
      formData.append("ledger_bill_to_bill", values.ledger_bill_to_bill || "")
      formData.append(
        "ledger_interest_rate",
        (values.ledger_interest_rate ?? "").toString()
      );
      formData.append("ledger_interest_style", values.ledger_interest_style || "");
      formData.append(
        "ledger_credit_limit_day",
        (values.ledger_credit_limit_day ?? "").toString()
      );
      formData.append(
        "ledger_reserve_fund",
        (values.ledger_reserve_fund ?? "").toString()
      );
      formData.append(
        "ledger_tds",
        (values.ledger_tds ?? "").toString()
      );
      formData.append(
        "ledger_credit_limit_amount",
        (values.ledger_credit_limit_amount ?? "").toString()
      );
      // formData.append("ledger_interest_rate", values.ledger_interest_rate || "");
      // formData.append("ledger_credit_limit_day", values.ledger_credit_limit_day || "");
      // formData.append("ledger_credit_limit_amount", values.ledger_credit_limit_amount || "");
      if (imageFile) {
        formData.append('attachments', imageFile); // ✅ binary file
      }

      formData.append(
        "ledger_deals_in_company",
        Array.isArray(values.ledger_deals_in_company)
          ? JSON.stringify(values.ledger_deals_in_company)
          : "[]"
      );

      formData.append(
        "ledger_deals_in_product",
        Array.isArray(values.ledger_deals_in_product)
          ? JSON.stringify(values.ledger_deals_in_product)
          : "[]"
      );

      // Dates
      if (values.ledger_dob) {
        formData.append("ledger_dob", values.ledger_dob.toISOString());
      }
      if (values.ledger_marriage_anniversary) {
        formData.append(
          "ledger_marriage_anniversary",
          values.ledger_marriage_anniversary.toISOString()
        );
      }
      if (values.ledger_work_anniversary) {
        formData.append(
          "ledger_work_anniversary",
          values.ledger_work_anniversary.toISOString()
        );
      }
      console.log("document data", values);
      // Multiple documents
      values.documents?.forEach((doc, index) => {
        formData.append(
          `documents[${index}][doc_type]`,
          doc.document_type
        );
        formData.append(
          `documents[${index}][doc_name]`,
          doc.document_name
        );



        if (doc.attachments && Array.isArray(doc.attachments)) {
          doc.attachments.forEach((file: any, fIndex: number) => {
            if (file?.originFileObj) {
              // send the actual file
              formData.append(
                `documents[${index}][doc_file][${fIndex}]`,
                file.originFileObj as File
              );
            } else if (file instanceof File) {
              // in case it's already a File
              formData.append(
                `documents[${index}][doc_file][${fIndex}]`,
                file
              );
            }
          });
        }
      });



      const method = isEditMode ? "put" : "post";
      const url = isEditMode ? "edit-ledger" : "add-ledger";

      const resp = await apiRequest<any>({
        method,
        url,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      showSuccess(isEditMode ? "Ledger updated!" : "Ledger created!");
      form.resetFields();
      if (!visible) { //check this
        setImageFile(null);
        setProfileImageFileList([]);
      }
      onCreate(resp);
      onCancel();
    } catch (err) {
      console.error(err);
      showError(isEditMode ? "Update failed" : "Create failed");
    }
  };




  const handleDiscountChange = (categoryId: number, value: string) => {
    setDiscounts((prev) => ({
      ...prev,
      [categoryId]: value,
    }));
  };

  // image preview 
  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as File);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
  };

  // Utility function to convert image to base64
  const getBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });

  const uploadButton = (
    <div
      style={{
        width: 220,
        height: 220,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <PlusOutlined style={{ fontSize: 24 }} />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );



  // Outside of return, in the same file
  const autoInsertSlash = (input: HTMLInputElement) => {
    let value = input.value.replace(/\D/g, ""); // Keep only digits

    // Insert slashes automatically after 2nd and 4th digits
    if (value.length > 2) value = value.slice(0, 2) + "/" + value.slice(2);
    if (value.length > 5) value = value.slice(0, 5) + "/" + value.slice(5);

    input.value = value;
  };

  const handleDOBKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    const input = e.currentTarget as HTMLInputElement; // Cast to input
    const value = input.value;

    const allowedSpecialKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Tab",
      "Escape",
      "Enter",
    ];

    // Allow Ctrl/⌘ + A/C/V/X
    if ((e.ctrlKey || e.metaKey) && ["a", "c", "v", "x"].includes(e.key.toLowerCase())) return;

    // Allow special keys
    if (allowedSpecialKeys.includes(e.key)) return;

    // Count digits in input
    const digitCount = (value.match(/\d/g) || []).length;

    // Allow digits only if less than 8 digits
    if (/^[0-9]$/.test(e.key)) {
      if (digitCount >= 8) {
        e.preventDefault();
        return;
      }
    } else if (e.key === "/" || e.key === "-") {
      // Allow slash or hyphen but max 2
      const count = (value.match(new RegExp(`\\${e.key}`, "g")) || []).length;
      if (count >= 2) {
        e.preventDefault();
        return;
      }
    } else {
      // Block everything else
      e.preventDefault();
      return;
    }

    // Auto-insert slash after 2nd and 4th digits
    setTimeout(() => autoInsertSlash(input), 0); // Timeout to let key input happen
  };

  // for persentage reserve fund, tsd
  // utils/inputValidators.ts
  const decimalInputKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    maxIntegerDigits = 3,
    maxDecimalDigits = 2,
    maxValue = 100
  ) => {
    const value = e.currentTarget.value;
    const key = e.key;
    const cursorPos = e.currentTarget.selectionStart || 0;

    // Allow copy, cut, paste, select-all
    if ((e.ctrlKey || e.metaKey) && ["c", "x", "v", "a"].includes(key.toLowerCase())) return;

    // Block invalid keys
    if (["-", "+", "e", "E", " "].includes(key)) {
      e.preventDefault();
      return;
    }

    // Allow navigation
    if (["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(key)) return;

    // Only digits & dot
    if (!/^[0-9.]$/.test(key)) {
      e.preventDefault();
      return;
    }

    // Dot cannot be first
    if (key === "." && value === "") {
      e.preventDefault();
      return;
    }

    // Only one dot
    if (key === "." && value.includes(".")) {
      e.preventDefault();
      return;
    }

    const parts = value.split(".");

    // Before dot: max integer digits
    if (!value.includes(".") && parts[0].length >= maxIntegerDigits && key !== ".") {
      e.preventDefault();
      return;
    }

    // After dot: max decimal digits considering cursor position
    if (value.includes(".") && cursorPos > value.indexOf(".")) {
      const decLength = value.length - value.indexOf(".") - 1;
      if (decLength >= maxDecimalDigits) {
        e.preventDefault();
        return;
      }
    }

    // Max value check
    const newValue = value + key;
    const num = parseFloat(newValue);
    if (!isNaN(num) && num > maxValue) {
      e.preventDefault();
    }
  };


  const decimalInputPaste = (
    e: React.ClipboardEvent<HTMLInputElement>,
    maxIntegerDigits = 3,
    maxDecimalDigits = 2,
    maxValue = 100
  ) => {
    const pasteValue = e.clipboardData.getData("text");

    // Allow only numbers + dot
    if (!/^[0-9.]+$/.test(pasteValue)) {
      e.preventDefault();
      return;
    }

    // Must match pattern: max integer & decimal digits
    const regex = new RegExp(`^\\d{1,${maxIntegerDigits}}(\\.\\d{0,${maxDecimalDigits}})?$`);
    if (!regex.test(pasteValue)) {
      e.preventDefault();
      return;
    }

    // Must not exceed maxValue
    if (parseFloat(pasteValue) > maxValue) {
      e.preventDefault();
      return;
    }
  };


  const handleTimeChange = (changedValues: any, allValues: any) => {
    if (!changedValues.payrolls) return;

    changedValues.payrolls.forEach((changedItem: any, index: number) => {
      const payroll = allValues.payrolls[index];
      if (!payroll) return;

      const { payroll_check_in, payroll_check_out } = payroll;

      if (payroll_check_in && payroll_check_out) {
        const start = dayjs(payroll_check_in);
        const end = dayjs(payroll_check_out);

        let diff = end.diff(start, "minute");
        if (diff < 0) diff += 24 * 60; // overnight shifts

        const hours = Math.floor(diff / 60);
        const minutes = diff % 60;

        const result = minutes > 0 ? `${hours}h ${minutes}m` : `${hours} hours`;

        form.setFields([
          {
            name: ["payrolls", index, "payroll_working_hours"],
            value: result,
          },
        ]);
      }
    });
  };




  return (
    <>
      <Modal
        visible={visible}
        title={isEditMode ? "Edit Ledger" : "Add Ledger"}
        onCancel={onCancel}
        footer={null}
        width="95%"
        destroyOnClose
        maskClosable={false}
        centered
      >

        <Form form={form} layout="vertical" onFinish={onFinish}
          onValuesChange={handleTimeChange}
          initialValues={{
            ledger_status: 1,
          }}>
          <>
            <span><h4 style={{ margin: "0 0 10px 0", padding: 0 }}>Ledger</h4></span>
            <Row gutter={16}>
              <Col span={16}>
                <Row gutter={16}>
                  {/* First Name */}
                  <Col span={12}>
                    <Form.Item name="ledger_first_name" label="First Name">
                      <Form.Item noStyle dependencies={["ledger_first_name"]}>
                        {({ getFieldValue, setFieldsValue }) => {
                          const currentValue = getFieldValue("ledger_first_name") || "";

                          const handleChange = (
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            let value = e.target.value;

                            // केवल alphabets allow
                            value = value.replace(/[^a-zA-Z]/g, "");

                            // limit 50 chars
                            value = value.slice(0, 50);

                            // पहला अक्षर capital
                            if (value.length > 0) {
                              value = value.charAt(0).toUpperCase() + value.slice(1);
                            }

                            // ✅ Sync with first phone contact's first_name
                            const phones = getFieldValue("phones") || [];
                            if (phones.length > 0) {
                              phones[0] = {
                                ...phones[0],
                                first_name: value,
                              };
                              setFieldsValue({
                                ledger_first_name: value,
                                phones: phones
                              });
                            } else {
                              setFieldsValue({ ledger_first_name: value });
                            }
                          };

                          return (
                            <Input
                              value={currentValue}
                              maxLength={50}
                              onChange={handleChange}
                              placeholder="Enter first name"
                              suffix={
                                <span style={{ fontSize: "12px", color: "#888" }}>
                                  {currentValue.length}/50
                                </span>
                              }
                            />
                          );
                        }}
                      </Form.Item>
                    </Form.Item>
                  </Col>


                  {/* Last Name */}
                  <Col span={12}>
                    <Form.Item name="ledger_last_name" label="Last Name">
                      <Form.Item noStyle dependencies={["ledger_last_name"]}>
                        {({ getFieldValue, setFieldsValue }) => {
                          const currentValue = getFieldValue("ledger_last_name") || "";

                          const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                            let value = e.target.value;

                            // केवल alphabets और space allow
                            value = value.replace(/[^a-zA-Z\s]/g, "");

                            // limit 50 chars
                            value = value.slice(0, 50);

                            // पहला अक्षर capital
                            if (value.length > 0) {
                              value = value.charAt(0).toUpperCase() + value.slice(1);
                            }

                            // ✅ Sync with first phone contact's last_name
                            const phones = getFieldValue("phones") || [];
                            if (phones.length > 0) {
                              phones[0] = {
                                ...phones[0],
                                last_name: value,
                              };
                              setFieldsValue({
                                ledger_last_name: value,
                                phones: phones
                              });
                            } else {
                              setFieldsValue({ ledger_last_name: value });
                            }
                          };

                          return (
                            <Input
                              value={currentValue}
                              maxLength={50}
                              onChange={handleChange}
                              placeholder="Enter last name"
                              suffix={
                                <span style={{ fontSize: "12px", color: "#888" }}>
                                  {currentValue.length}/50
                                </span>
                              }
                            />
                          );
                        }}
                      </Form.Item>
                    </Form.Item>
                  </Col>


                  {/* Account Head */}
                  <Col span={12}>
                    <Form.Item name="ledger_account_head" label="Account Head">
                      <Select placeholder="Select head" allowClear>
                        {accountHeads.map((h) => (
                          <Option key={h.ah_id} value={h.ah_id}>
                            {h.ah_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>

                  </Col>

                  {/* Account Sub Head */}
                  <Col span={12}>
                    <Form.Item name="ledger_sub_account_head" label="Sub Head">
                      <Select placeholder="Select sub-head" allowClear>
                        {subHeads.map((sh) => (
                          <Option key={sh.ah_id} value={sh.ah_id}>
                            {sh.ah_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                </Row>
              </Col>
              <Col span={8}>
                {/* ledger image */}
                <Row justify="center">
                  <Col>
                    <Form.Item label="Upload Ledger Image"  >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: 'center',
                        }}
                      >
                        <Upload
                          beforeUpload={() => false}
                          listType="picture-card"
                          maxCount={1}
                          fileList={profileImageFileList}
                          onPreview={handlePreview} // 👈 Add this
                          onChange={({ fileList }) => {
                            setProfileImageFileList(fileList);
                            const rawFile = fileList[0]?.originFileObj;
                            if (rawFile instanceof File) {
                              setImageFile(rawFile); // ✅ set real File here
                            } else {
                              setImageFile(null);
                            }
                          }}
                        >
                          {profileImageFileList.length >= 1 ? null : uploadButton}
                        </Upload>
                      </div>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>


              {/* Mobile Number */}
              <Col span={8}>
                <Form.Item
                  name="ledger_mobile_no"
                  label="Mobile No"
                  rules={[
                    { required: true, message: "Required" },
                    {
                      pattern: /^[0-9]{10}$/,
                      message: "Mobile number must be 10 digits",
                    },
                  ]}
                >
                  <Form.Item noStyle dependencies={["ledger_mobile_no"]}>
                    {({ getFieldValue, setFieldsValue }) => {
                      const currentValue = getFieldValue("ledger_mobile_no") || "";

                      const handleChange = (
                        e: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        let value = e.target.value;

                        // Allow only digits
                        value = value.replace(/[^0-9]/g, "");

                        // Limit to 10 digits
                        value = value.slice(0, 10);

                        setFieldsValue({ ledger_mobile_no: value });
                      };

                      const handleBlur = () => {
                        const value = getFieldValue("ledger_mobile_no") || "";
                        if (!value) {
                          setFieldsValue({ ledger_mobile_no: "" });
                        }
                      };

                      return (
                        <Input
                          value={currentValue}
                          maxLength={10}
                          type="tel"
                          placeholder="Enter mobile number"
                          onChange={handleChange}
                          onBlur={handleBlur} // <-- Auto-fill here
                          suffix={
                            <span style={{ fontSize: "12px", color: "#888" }}>
                              {currentValue.length}/10
                            </span>
                          }
                        />
                      );
                    }}
                  </Form.Item>
                </Form.Item>
              </Col>

              {/*  Date of Birth */}
              <Col span={8}>
                <Form.Item
                  name="ledger_dob"
                  label="Date of Birth"
                  rules={[
                    { required: false, message: "Date of Birth is required" },
                    {
                      validator: (_, value) => {
                        if (!value) return Promise.resolve();

                        const today = dayjs();
                        const minDate = dayjs().subtract(120, "years");

                        if (value.isAfter(today)) {
                          return Promise.reject("DOB cannot be in the future");
                        }
                        if (value.isBefore(minDate)) {
                          return Promise.reject("DOB cannot be more than 120 years old");
                        }
                        return Promise.resolve();
                      }
                    }
                  ]}
                >
                  <Form.Item noStyle dependencies={["ledger_dob"]}>
                    {({ getFieldValue, setFieldsValue }) => {
                      const currentValue = getFieldValue("ledger_dob") || null;

                      const handleDOBChange = (date: any) => {
                        setFieldsValue({ ledger_dob: date });  // ✅ ONLY update DOB — no sync with phones
                      };

                      return (
                        // <DatePicker
                        //   value={currentValue}
                        //   onChange={handleDOBChange}
                        //   style={{ width: "100%", borderRadius: "4px" }}
                        //   format={["DD/MM/YYYY"]}
                        //   disabledDate={(current) =>
                        //     current && (current > dayjs() || current < dayjs().subtract(120, "years"))
                        //   }
                        //   onKeyDown={(e: React.KeyboardEvent<HTMLElement>) => {
                        //      const input = e.currentTarget as HTMLInputElement; // <-- cast to input
                        //     const value = input.value;
                        //     const allowedSpecialKeys = [
                        //       "Backspace",
                        //       "Delete",
                        //       "ArrowLeft",
                        //       "ArrowRight",
                        //       "ArrowUp",
                        //       "ArrowDown",
                        //       "Tab",
                        //       "Escape",
                        //       "Enter",
                        //     ];

                        //     // Allow Ctrl/⌘ + A/C/V/X
                        //     if (
                        //       (e.ctrlKey || e.metaKey) &&
                        //       ["a", "c", "v", "x"].includes(e.key.toLowerCase())
                        //     ) {
                        //       return;
                        //     }

                        //     // Allow special keys
                        //     if (allowedSpecialKeys.includes(e.key)) {
                        //       return;
                        //     }

                        //     // Count digits in input
                        //     const digitCount = (value.match(/\d/g) || []).length;

                        //     // Allow digits only if less than 8 digits
                        //     if (/^[0-9]$/.test(e.key)) {
                        //       if (digitCount < 8) return;
                        //       e.preventDefault();
                        //       return;
                        //     }

                        //      // ✔ Allow slash, but max 2
                        //     if (e.key === "/") {
                        //       if ((value.match(/\//g) || []).length < 2) return;
                        //       e.preventDefault();
                        //       return;
                        //     }

                        //     // ✔ Allow hyphen, but max 2
                        //     if (e.key === "-") {
                        //       if ((value.match(/-/g) || []).length < 2) return;
                        //       e.preventDefault();
                        //       return;
                        //     }

                        //     // ❌ Block everything else
                        //     e.preventDefault();
                        //   }}
                        // />
                        <DatePicker
                          value={currentValue}
                          onChange={handleDOBChange}
                          style={{ width: "100%", borderRadius: "4px" }}
                          format={["DD/MM/YYYY"]}
                          disabledDate={(current) =>
                            current && (current > dayjs() || current < dayjs().subtract(120, "years"))
                          }
                          onKeyDown={handleDOBKeyDown} // ✅ Reusing the function
                        />

                      );
                    }}
                  </Form.Item>
                </Form.Item>
              </Col>





              {/* Email */}
              <Col span={8}>
                <Form.Item
                  name="ledger_email"
                  label="Email"
                  rules={[
                    { type: 'email', message: 'Please enter a valid email address' },
                  ]}
                >
                  <Input
                    placeholder="example@email.com"
                    maxLength={100}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      let value = e.target.value;

                      // Allow only email-related characters: letters, numbers, @, ., -, _
                      value = value.replace(/[^a-zA-Z0-9@._-]/g, "");

                      // Convert to lowercase and limit to 100 chars
                      value = value.toLowerCase().slice(0, 100);

                      // Only update this field
                      form.setFieldsValue({ ledger_email: value });
                    }}
                    onPaste={(e) => {
                      // Prevent pasting invalid characters
                      const paste = e.clipboardData.getData('text');
                      if (/[^a-zA-Z0-9@._-]/.test(paste)) {
                        e.preventDefault();
                      }
                    }}
                    onCopy={(e) => {
                      // Optional: allow copy but could clean text if needed
                    }}
                    suffix={
                      <span style={{ fontSize: "12px", color: "#888" }}>
                        {(form.getFieldValue("ledger_email") || "").length}/100
                      </span>
                    }
                  />
                </Form.Item>
              </Col>



              {/* ledger_status */}
              <Col span={8}>
                <Form.Item name="ledger_status" label="Status">
                  <Select allowClear placeholder="Select status">
                    <Option value={1}>Active</Option>
                    <Option value={0}>Inactive</Option>
                  </Select>
                </Form.Item>
              </Col>


              {/* <Divider style={{ marginTop: 4, marginBottom: 16 }} /> */}

              <Form.Item shouldUpdate noStyle>
                {(form) => (
                  <div style={{
                    background: "#f5f5f5",
                    width: "98%",
                    margin: "0 auto 20px auto",
                    padding: "24px 8px",
                    borderRadius: "6px",
                    // margin: '0 0 20px 0',
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}>
                    <Row
                      gutter={16}
                      style={{
                        margin: 0,
                        alignItems: "center",
                      }}
                    >
                      <Col span={12}>
                        <span><h4 style={{ margin: "10px 0 10px 0", padding: 0 }}>Company Info </h4></span>
                      </Col>

                      <Col span={12} style={{ textAlign: "right" }}>
                        <Button
                          type="text"
                          size="small"
                          icon={companyCollapsed ? <CaretUpOutlined /> : <CaretDownOutlined />}
                          onClick={() => setCompanyCollapsed(!companyCollapsed)}
                        >
                          {companyCollapsed ? "Hide" : "Add"}
                        </Button>
                      </Col>
                    </Row>
                    {/* Company Details block */}
                    {companyCollapsed && (
                      <div
                        style={{
                          background: "#f5f5f5",
                          borderRadius: "6px",
                          marginTop: 16,
                          position: "relative",
                        }}
                      >
                        <Row gutter={16}>
                          {/* Company Name */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_company_name"
                              label="Company Name"
                              rules={[
                                { required: false, message: "Company Name is required" },
                                {
                                  pattern: /^[A-Za-z0-9&.,'()\- ]+$/,
                                  message: "Company Name contains invalid characters",
                                },
                                {
                                  pattern: /^(?!\d+$).+$/,
                                  message: "Company Name cannot be only numbers",
                                },
                              ]}
                            >
                              <Form.Item noStyle dependencies={["ledger_company_name"]}>
                                {({ getFieldValue, setFieldsValue }) => {
                                  const currentValue = getFieldValue("ledger_company_name") || "";

                                  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                                    let value = e.target.value;

                                    // ❌ DO NOT remove numbers
                                    // ❌ DO NOT remove special company characters
                                    // Only remove completely invalid characters (emoji etc.)
                                    value = value.replace(/[^A-Za-z0-9&.,'()\- ]/g, "");

                                    // Max 100 chars
                                    value = value.slice(0, 100);

                                    // First letter uppercase
                                    if (value.length > 0) {
                                      value = value.charAt(0).toUpperCase() + value.slice(1);
                                    }

                                    setFieldsValue({ ledger_company_name: value });
                                  };

                                  return (
                                    <Input
                                      value={currentValue}
                                      maxLength={100}
                                      onChange={handleChange}
                                      placeholder="Enter company name"
                                      style={{ background: "#f5f5f5" }}
                                      suffix={
                                        <span style={{ fontSize: "12px", color: "#888", }}>
                                          {currentValue.length}/100
                                        </span>
                                      }
                                    />
                                  );
                                }}
                              </Form.Item>
                            </Form.Item>
                          </Col>



                          {/* GSTIN/UIN */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_gstin"
                              label="GSTIN/UIN"
                              rules={[
                                {
                                  pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                                  message: "Enter valid 15-character GSTIN",
                                },
                              ]}
                              getValueFromEvent={(e) => {
                                let value = e.target.value;
                                value = value.replace(/[^0-9a-zA-Z]/g, "").toUpperCase();
                                if (value.length > 15) value = value.slice(0, 15);
                                return value;
                              }}
                            >
                              <Input
                                placeholder="Enter GSTIN"
                                maxLength={15}
                                style={{ background: "#f5f5f5" }}
                                onChange={(e) => {
                                  const counterEl = document.getElementById("gstin-counter");
                                  if (counterEl) counterEl.innerText = `${e.target.value.length}/15`;
                                }}
                                suffix={
                                  <span id="gstin-counter" style={{ fontSize: "12px", color: "#888" }}>
                                    0/15
                                  </span>
                                }
                                onBlur={async (e) => {
                                  const gstin = e.target.value.trim();
                                  if (!gstin) return;

                                  // ✅ Extract PAN from GSTIN (characters 3-12)
                                  if (gstin.length === 15) {
                                    const panFromGstin = gstin.slice(2, 12);
                                    form.setFieldsValue({ ledger_pan_no: panFromGstin });
                                  }

                                  // ✅ GSTIN API validation
                                  try {
                                    const response = await apiRequest({
                                      url: "check-gstin",
                                      method: "get",
                                      params: { gstIn: gstin },
                                    });

                                    if (response?.data) {
                                      // GSTIN is valid, optionally show success
                                    } else {
                                      showSuccess(response?.message || "Found GSTIN");
                                    }
                                  } catch (err) {
                                    showError("Failed to validate GSTIN");
                                    console.error(err);
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>

                          {/* Pan no.  */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_pan_no"
                              label="PAN No"
                              rules={[
                                {
                                  pattern: /^[A-Z0-9]{10}$/,
                                  message: "Enter valid 10-character PAN No",
                                },
                              ]}
                              getValueFromEvent={(e) => {
                                let value = e.target.value;

                                // Sirf numbers aur alphabets allow karo
                                value = value.replace(/[^0-9a-zA-Z]/g, "");

                                // Auto-uppercase me convert karo
                                value = value.toUpperCase();

                                // Max 10 characters limit
                                if (value.length > 10) {
                                  value = value.slice(0, 10);
                                }

                                return value;
                              }}
                            >
                              <Input
                                placeholder="Enter PAN No"
                                maxLength={10}
                                style={{ background: "#f5f5f5" }}
                                onChange={(e) => {
                                  // Live counter update
                                  const counterEl = document.getElementById("pan-counter");
                                  if (counterEl) {
                                    counterEl.innerText = `${e.target.value.length}/10`;
                                  }
                                }}
                                suffix={
                                  <span
                                    id="pan-counter"
                                    style={{ fontSize: "12px", color: "#888" }}
                                  >
                                    0/10
                                  </span>
                                }
                              />
                            </Form.Item>
                          </Col>

                          {/* Tin No */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_tin_no"
                              label="TIN No"
                              style={{ background: "#f5f5f5" }}
                              rules={[
                                {
                                  pattern: /^[0-9]{11}$/,
                                  message: "TIN must be exactly 11 digits",
                                },
                              ]}
                            >
                              <Input
                                maxLength={11}
                                placeholder="Enter TIN No"
                                style={{ background: "#f5f5f5" }}
                                onChange={(e) => {
                                  const digitsOnly = e.target.value.replace(/\D/g, "");
                                  form.setFieldsValue({ ledger_tin_no: digitsOnly });

                                  const counterEl = document.getElementById("tin-counter");
                                  if (counterEl) {
                                    counterEl.innerText = `${digitsOnly.length}/11`;
                                    counterEl.style.color = digitsOnly.length === 11 ? "red" : "#888";
                                  }
                                }}
                                suffix={
                                  <span id="tin-counter" style={{ fontSize: "12px", color: "#888" }}>
                                    0/11
                                  </span>
                                }
                              />
                            </Form.Item>
                          </Col>

                          {/* Cin No */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_cin_no"
                              label="CIN No"
                              style={{ background: "#f5f5f5" }}
                              rules={[
                                {
                                  pattern: /^[LU][0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/,
                                  message: "Valid CIN format required (e.g., U12345MH2006PTC123456)",
                                },
                              ]}
                            >
                              <Input
                                maxLength={21}
                                placeholder="e.g., U12345MH2006PTC123456"
                                style={{ background: "#f5f5f5" }}
                                onChange={(e) => {
                                  const upperCaseValue = e.target.value.toUpperCase();
                                  form.setFieldsValue({ ledger_cin_no: upperCaseValue });

                                  const counterEl = document.getElementById("cin-counter");
                                  if (counterEl) {
                                    counterEl.innerText = `${upperCaseValue.length}/21`;
                                    counterEl.style.color =
                                      upperCaseValue.length === 21 ? "red" : "#888";
                                  }
                                }}
                                suffix={
                                  <span
                                    id="cin-counter"
                                    style={{ fontSize: "12px", color: "#888" }}
                                  >
                                    0/21
                                  </span>
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    )}
                  </div>
                )}
              </Form.Item>
            </Row>

            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginTop: 16 }}
                >
                  {isEditMode ? "Update" : "Add"}
                </Button>
              </Form.Item>
            </div>
          </>
        </Form>
      </Modal>

      <Modal
        visible={previewOpen}
        title={previewTitle}
        footer={null}
        centered
        onCancel={() => setPreviewOpen(false)}
      >
        <img
          alt="Preview"
          style={{ width: '100%' }}
          src={previewImage}
        />
      </Modal>
    </>
  );
};

export default LedgerModal;

